<template>
  <b-skeleton-wrapper :loading="loading">
    <template #loading>
      <div class="bg-gray-50 rounded-lg p-4 flex flex-col items-start justify-center shadow-sm">
        <b-skeleton animation="wave" width="50%" height="14px" class="mb-1"></b-skeleton>
        <div class="flex items-center gap-2 mt-1">
          <b-skeleton animation="wave" width="70px" height="36px"></b-skeleton>
          <b-skeleton animation="wave" width="20px" height="20px"></b-skeleton>
        </div>
      </div>
    </template>
    <div class="bg-gray-50 rounded-lg p-4 flex flex-col items-start justify-center shadow-sm">
      <p class="text-gray-600 text-sm font-medium mb-1">Precisión General</p>
      <div class="flex items-center">
        <p class="text-4xl font-bold text-gray-800">{{ Math.round(kpi.accuracy) }}%</p>
        <Trend :trend="kpi.trend" />
      </div>
    </div>
  </b-skeleton-wrapper>
</template>

<script>
import { getAccuracyKpi } from "@/services/stats.service.js";
import Trend from './Trend.vue';

export default {
  name: 'OverallAccuracyKPI',

  components: {
    Trend,
  },

  data() {
    return {
      loading: true,
      kpi: {
        accuracy: 0.0,
        trend: "NONE"  // Se llenará con "UP", "DOWN", "SAME" o "NONE"
      }
    };
  },

  props: {
    receivedTimeRange: {
      type: String,
      default: ''
    },
    isPremium: {
      type: Boolean,
      default: true
    },
    forStudentId: {
      type: [Number, String],
      default: null
    }
  },

  watch: {
    receivedTimeRange(timeRange) {
      if (!this.isPremium) return;
      this.loadAccuracyKPI(timeRange);
    },
    isPremium(newValue) {
      if (newValue && this.receivedTimeRange) {
        this.loading = true;
        this.loadAccuracyKPI(this.receivedTimeRange);
      }
    },
    forStudentId() {
      if (this.isPremium && this.receivedTimeRange) {
        this.loading = true;
        this.loadAccuracyKPI(this.receivedTimeRange);
      }
    }
  },

  created() {
    // Si no es premium, mantener loading indefinidamente y no cargar datos
    if (!this.isPremium) {
      this.loading = true;
      return;
    }
    
    this.loadAccuracyKPI(this.receivedTimeRange);
  },

  mounted() {
    // Si no es premium, mantener skeleton indefinidamente
    if (!this.isPremium) {
      this.loading = true;
    }
  },

  methods: {
    async loadAccuracyKPI(timeRange) {
      if (timeRange === '' || !this.isPremium) {
        return;
      }

      this.kpi = await getAccuracyKpi(timeRange, this.forStudentId);
      this.loading = false; // Ocultar skeleton inmediatamente después de cargar
    }
  },

};
</script>
